import $ from 'jquery';
import {Swiper, Autoplay, Navigation} from 'swiper/js/swiper.esm.js';
Swiper.use([Autoplay, Navigation]);
import lightGallery from 'lightgallery';

const modalSlider = new Swiper('.modal-slider', {
    watchOverflow: true,
    autoHeight: true,
    spaceBetween: 15,
    slidesPerView: 1,
    breakpoints: {
        400: {
            slidesPerView: 2
        },
        650: {
            slidesPerView: 3
        },
        850: {
            slidesPerView: 4
        },
        1150: {
            slidesPerView: 5
        },
        1350: {
            slidesPerView: 6
        }
    },
    navigation: {
        nextEl: ".modal-slider-swiper-button-next",
        prevEl: ".modal-slider-swiper-button-prev",
    }
});

lightGallery(document.getElementById('modal-slider-wrapper'), {
    prevHtml: '<svg class="icon icon--arrow icon--reverse"><use xlink:href="' +  wp.theme_path + '/assets/icons/icons.svg#arrow' + '"></use></svg>',
    nextHtml: '<svg class="icon icon--arrow"><use xlink:href="' + wp.theme_path + '/assets/icons/icons.svg#arrow' + '"></use></svg>',
    download: false
});